import fetch from "lib/fetch";
import type { ReportingInterface } from "types/reference";

type ReportingListResponse = { data: Array<ReportingInterface> };

export const getReportingRequest = (languageCode: string) =>
    fetch.get<ReportingListResponse>(`reference/reporting/${languageCode}`);
